/* import __COLOCATED_TEMPLATE__ from './posting-results-list-item.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import clsx from 'clsx';

import { POSTING__APPLICATION_EXPIRATION_STATUSES_ALLOWED } from 'sh-www/constants/routes/posting';

const CLASS_NAME = 'SH-c-posting-results-list-item';

/** @module */
class AdminPostingResultsListItemComponent extends Component {
  @service media;
  @service moment;
  @service router;
  @service session;
  @service store;

  @tracked hasMouseEntered = false;

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
      this.isHighlight && 'highlighted',
      this.hasMouseEntered && 'has-mouse'
    );
  }

  get sellerName() {
    const { seller } = this.args.application;
    const { currentUser } = this.session;

    return currentUser.isBuyer && currentUser.company.isNeedsCreditCard
      ? seller.fullNameSingleLastDigit
      : seller.fullName;
  }

  get isHighlight() {
    return this.args.application.isUnread;
  }

  get pitchText() {
    return this.args.application.pitch?.headline ?? '';
  }

  get isShowExpirationWarning() {
    const expiresAt = this.args.application.expiresAt;
    if (!expiresAt) return false;

    const threeDaysFromNow = this.moment.moment().add(3, 'd');
    const isWithinReminderTimeLimit = expiresAt.getTime() < threeDaysFromNow.toDate().getTime();

    return isWithinReminderTimeLimit
      && POSTING__APPLICATION_EXPIRATION_STATUSES_ALLOWED.includes(this.args.application.status);
  }

  @action
  onMouseEnter() {
    if (this.media.isMobile) return;

    this.hasMouseEntered = true;
  }

  @action
  onMouseLeave() {
    if (this.media.isMobile) return;

    this.hasMouseEntered = false;
  }
}

export default AdminPostingResultsListItemComponent;
